import { useEffect } from 'react';
import { setSketchObjectLibraryHost } from '../../../potree/sketchObjects/registry';
import { useProjectObjectLibraryQuery } from '../../../types/graphqlTypes';
import { applyObjectLibrary, clearObjectLibrary } from './objectLibraryRegistration';
import { useObjectLibraryEvents } from './useObjectLibraryEvents';

/**
 * The project's organisation library, live: its published custom objects
 * become sketch-object types (placed ones render, the picker lists them) and
 * its configuration shapes the picker. Refetched when the organisation
 * publishes; cleared when the project page goes.
 */
export const useProjectObjectLibrary = ({ projectId, organisationId, readOnly }: { projectId: string; organisationId: string; readOnly: boolean }) => {
  const { data, refetch } = useProjectObjectLibraryQuery({ variables: { projectId }, skip: !projectId, fetchPolicy: 'cache-and-network' });
  const library = data?.projectObjectLibrary;

  useEffect(() => {
    if (library) applyObjectLibrary(library);
  }, [library]);

  useEffect(() => {
    const canManage = !!library?.canEdit && !readOnly;
    // A new tab: the project (and whatever the user was doing in it) stays open.
    setSketchObjectLibraryHost({ canManage, openManager: () => window.open(`/organisations/${organisationId}/object-library`, '_blank', 'noopener') });
  }, [library?.canEdit, readOnly, organisationId]);

  useEffect(
    () => () => {
      setSketchObjectLibraryHost(null);
      clearObjectLibrary();
    },
    [],
  );

  useObjectLibraryEvents({ organisationId: library?.organisationId, onChanged: () => void refetch() });
};
